export default "/assets/images/big-sneeze5.7f0608d73871f5ac.png";